import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { curriculumProgressApi } from '~/curriculum/apis/curriculum-progress.api'
import useGetCurriculumCountryCodeForURL from '~/curriculum/hooks/useGetCurriculumCountryCode'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { selectSelectedGrade, selectSubjectOrder } from '~/redux/slices/dashboard'
import ROUTES from '~/shared/constants/routes.const'

import { BootcampPageUrlParamsType } from '../types/bootcamp.types'

export default function useBackToCurriculumPath(): string {
  const dispatch = useAppDispatch()

  const selectedGrade = useAppSelector(selectSelectedGrade)
  const curriculumCountryCode = useGetCurriculumCountryCodeForURL()
  const bootcampListLink = useGetBackFromBootcampUrl()
  const selectedSubjectOrder = useAppSelector(selectSubjectOrder)

  useEffect(() => {
    dispatch(curriculumProgressApi.util.invalidateTags(['curriculumLevelProgress']))
  }, [dispatch])

  return selectedGrade
    ? `${ROUTES.CURRICULUM}/${curriculumCountryCode}/${selectedGrade}/${selectedSubjectOrder}`
    : bootcampListLink
}

export function useGetBackFromBootcampUrl(config?: { isNavigateToLearningPath?: boolean }): string {
  const router = useRouter()
  const { query } = router
  const { key, subtopic } = query as unknown as BootcampPageUrlParamsType
  return config?.isNavigateToLearningPath ? `${ROUTES.LEARNING_PATH}` : `${ROUTES.BOOTCAMP}/${subtopic}/${key}`
}
